<template>
    <div class="animated fadeIn page-new">
        <b-row>
            <b-form @submit.prevent="save" action="111" class="col-md-12" aria-autocomplete="none" :autocomplete="false">
                <b-row>
                    <b-col sm="12" class="main-page">
                        <b-card footer-tag="footer">
                            <div slot="header">
                                <strong>Thêm quản trị viên</strong>
                            </div>
                            <b-row  v-bind:class="{'ptt-loading':loading}">
                                <b-col cols="12" xl="6" lg="8">
                                    <b-form-group
                                            label="Tên quản trị viên"
                                            label-for="input-name"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-name" type="text" placeholder="Nhập tên quản trị viên"  v-model="data.name"></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                            label="Địa chỉ email"
                                            label-for="input-email"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input
                                          id="input-email"
                                          autocomplete="off"
                                          type="email" placeholder="Nhập email quản trị viên"  v-model="data.email"></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                            label="Mật khẩu"
                                            label-for="input-pass"
                                            autocomplete="off"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-pass" type="password" placeholder="Nhập mật khẩu"  v-model="data.password"></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                            label="Nhập lại mật khẩu"
                                            label-for="input-pass2"
                                            :label-cols="2"
                                            :horizontal="true">
                                        <b-form-input id="input-pass2" type="password" placeholder="Nhập lại mật khẩu"  v-model="password2"></b-form-input>
                                    </b-form-group>

                                    <b-row>
                                        <b-col cols="12" xl="8" lg="8">
                                            <b-form-group
                                                    label="Trạng thái"
                                                    label-for="input-status"
                                                    :label-cols="4"
                                                    :horizontal="true">
                                                <b-form-select id="input-status" v-model="data.status">
                                                    <option :value="1">Đang hoạt động</option>
                                                    <option :value="2">Ngừng hoạt động</option>
                                                    <option :value="3">Tạm Khóa</option>
                                                </b-form-select>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>

                                </b-col>
                            </b-row>
                            <div slot="footer" class="">
                                <b-button type="submit" variant="primary">Tạo quản trị viên</b-button>
                                <b-button type="button" class="ml-2" :to="{path:'/admin'}">Quay lại</b-button>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </b-form>
        </b-row>
    </div>
</template>

<script>
    import axios from "axios";
    import {isAuth, isSuperAdmin} from "@/utils/auth";

    export default {
        name: 'AdminAdd',
        components: {

        },
        data () {
            return {
                data:{
                    name:'',
                    email: '',
                    password: '',
                    phone: null,
                    image: null,
                    status: 1,
                },
                password2: null,
                loading:false,
                group:[]
            }
        },
        mounted() {
          if (!isAuth() || !isSuperAdmin()) {
            this.$router.push('/login')
          }
        },
      created() {
        },
        computed: {

        },
        watch: {

        },
        methods: {
            async save(){
                const user = this.$cookies.get('user');
                this.$gtag.event('click_create_admin', {
                  event_category: 'click_events',
                  event_label: 'Create admin button',
                  user_type: 'admin',
                  user_id: user?._id,
                });
                //kiem tra bat buoc
                if(!this.data.name){
                    this.$toasted.show("Vui lòng nhập tên",{
                        type:"error",
                        duration:5000
                    });
                    return false;
                }
                if(!this.data.email){
                    this.$toasted.show("Vui lòng nhập địa chỉ email",{
                        type:"error",
                        duration:5000
                    });
                    return false;
                }

                if(!this.data.password){
                    this.$toasted.show("Vui lòng nhập mật khẩu",{
                        type:"error",
                        duration:5000
                    });
                    return false;
                }

                if(this.data.password !== this.password2){
                    this.$toasted.show("Nhập lại mật khẩu không chính xác",{
                        type:"error",
                        duration:5000
                    });
                    return false;
                }

                try {
                  // Lấy token từ cookies
                  const token = this.$cookies.get('token');

                  let params = {
                    user: {
                      email: this.data.email,
                      username: this.data.name,
                      password: this.data.password,
                      fullName: this.data.name
                    }
                  }

                  // Gửi yêu cầu API bằng Axios và đưa token vào header
                  const {data} = await axios.post(this.$configs.api + '/api/v4/cp/admin/register',
                    params, {
                    headers: {
                      Authorization: `Bearer ${token}`
                    },

                  });

                  this.$gtag.event('create_admin', {
                    event_category: 'admin_events',
                    event_label: 'Create admin',
                    user_type: 'admin',
                    user_id: user?._id,
                    req: JSON.stringify(params) || null,
                    res: JSON.stringify(data) || null,
                  });

                  if (data && data._id) {
                    this.$toasted.success("Đã lưu thành công",{
                      duration:5000
                    });
                    this.$router.push({ path: `/admin/${data._id}` })
                  }
                } catch (err) {
                    // Kiểm tra xem có lỗi phản hồi từ máy chủ không
                    if (err.response && err.response.status === 500) {

                      this.$toasted.error( err.response.data.message || "Đã xảy ra lỗi không mong muốn từ máy chủ", {
                        duration: 5000
                      });
                    } else {
                      // Xử lý các lỗi khác
                      this.$toasted.error(err.message, {
                        duration: 5000
                      });
                  }
                }
            }
        }
    }
</script>

